import styled from "styled-components";
import { GRAY_300 } from "../../Config/colors";
import Colors from "../../Constant/Colors";
import { STYLES } from "../../Constant/Theme";
import SmartImage from "../SmartImage";

export const OutlinedButton = styled.div`
  background-color: ${(props) =>
    props.disabled ? Colors.disabled : Colors.primary};
  border-radius: 5px;
  height: 35px;
  width: 100%;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;

  ${STYLES.HorizontalAlign}
`;
export const Icon = styled(SmartImage)`
  margin-left: 15px;
  margin-right: 15px;
`;
